import { render, staticRenderFns } from "./DoctorAvatarAddModal.vue?vue&type=template&id=2be564b0&scoped=true"
import script from "./DoctorAvatarAddModal.vue?vue&type=script&lang=js"
export * from "./DoctorAvatarAddModal.vue?vue&type=script&lang=js"
import style0 from "./DoctorAvatarAddModal.vue?vue&type=style&index=0&id=2be564b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be564b0",
  null
  
)

export default component.exports